import { getQueryClient } from '~/query';

export const invalidateQueries = (queryKey: string[]) => {
  const queryClient = getQueryClient();

  queryClient.invalidateQueries({ queryKey });
};
